import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

let injected = false;

function injectSrc(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

function injectInline(code) {
  const s = document.createElement("script");
  s.text = code;
  document.head.appendChild(s);
}

// Injects GA4 + Meta Pixel from admin-configured IDs and tracks SPA route changes.
export function AnalyticsScripts() {
  const location = useLocation();
  const cfg = useRef({});

  useEffect(() => {
    api.get("/site-config").then(({ data }) => {
      cfg.current = data;
      if (injected) return;
      injected = true;
      // Load gtag.js once — shared by GA4 and Google Ads.
      const gtagId = data.ga4_id || data.google_ads_id;
      if (gtagId) {
        injectSrc(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`);
        let code = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());`;
        if (data.ga4_id) code += `gtag('config','${data.ga4_id}');`;
        if (data.google_ads_id) code += `gtag('config','${data.google_ads_id}');`;
        injectInline(code);
      }
      if (data.google_ads_id && data.google_ads_purchase_label) {
        window.__ADS_PURCHASE_SEND_TO = `${data.google_ads_id}/${data.google_ads_purchase_label}`;
      }
      if (data.meta_pixel_id) {
        injectInline(`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${data.meta_pixel_id}');fbq('track','PageView');`);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (window.gtag && cfg.current.ga4_id) window.gtag("event", "page_view", { page_path: path });
    if (window.fbq && cfg.current.meta_pixel_id) window.fbq("track", "PageView");
  }, [location]);

  return null;
}
